import type {
  DetailedProgramView as GeneratedDetailedProgramView,
  ProgrammingRangeProgramView as GeneratedProgrammingRangeProgramView,
  SimpleProgramView as GeneratedSimpleProgramView,
} from "@/.generated/hey/v4b-backend/types.gen";

import { mapSubprograms } from "@/data/api/v4b/program/subprogram.mapping";
import {
  defaultProgramColorName,
  ProgramDetails,
  type Program,
  type SiteProgramOverview,
} from "@/domains/v4b/program/program.types";
import { brandNumber } from "@/utils/branded";

export function mapProgram(programView: GeneratedProgrammingRangeProgramView): Program {
  return {
    id: brandNumber(programView.id),
    name: programView.name,
    frontDisplayColor: programView.frontColorDisplay ?? defaultProgramColorName,
  };
}

export function mapSiteProgramOverviews(programs: GeneratedSimpleProgramView[]): SiteProgramOverview[] {
  return programs.map((program) => ({
    id: brandNumber(program.id),
    name: program.name,
    siteId: brandNumber(program.siteId),
    programType: program.programType,
    isActive: program.isActive ?? false,
    isSiteDefault: program.isSiteDefault,
    frontDisplayColor: program.frontColorDisplay ?? defaultProgramColorName,
  }));
}

export function mapProgramDetails(program: GeneratedDetailedProgramView): ProgramDetails {
  return {
    id: brandNumber(program.id),
    name: program.name,
    siteId: brandNumber(program.siteId),
    isSiteDefault: program.isSiteDefault,
    frontDisplayColor: program.frontColorDisplay ?? defaultProgramColorName,
    subprograms: mapSubprograms(program.subprograms),
  };
}
